// ─────────────────────────────────────────────────────────────────────────────
// 🔑 THE ESTIMATE RATES — SERVED, NEVER TYPED (Hannah, 2026-11-03).
// The Loan Estimate's basis: backend constants/feeSchedule ANNUAL_TAX_RATE / ANNUAL_HOI_RATE, property tax and homeowners
// insurance as a share of the PRICE a year, served by GET /api/fee-schedule (smartEstimate.leBasis — the same payload the
// SmartEstimate card and the FAQ read). Every screen that estimates a payment reads them here; until they arrive, or if
// they can't be read, the screen shows no estimate ("—"), never a typed figure (backend/test/hoiRateParity,
// noHardcodedRates, estimateRatesParity).
// ─────────────────────────────────────────────────────────────────────────────
import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
let pending = null;

/** The served basis, once per page load: → Promise<{ tax, hoi } | null>. */
export function fetchEstimateRates() {
  if (!pending) {
    pending = fetch(`${API_URL}/api/fee-schedule`)
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => {
        const b = j && j.smartEstimate && j.smartEstimate.leBasis;
        const tax = b ? Number(b.annualTaxRate) : NaN; const hoi = b ? Number(b.annualHoiRate) : NaN;
        return Number.isFinite(tax) && Number.isFinite(hoi) ? { tax, hoi } : null;
      })
      .catch(() => null)
      .then((v) => { if (!v) pending = null; return v; });
  }
  return pending;
}

/** { tax, hoi } once served, else null. */
export function useEstimateRates() {
  const [rates, setRates] = useState(null);
  useEffect(() => {
    let alive = true;
    fetchEstimateRates().then((v) => { if (alive && v) setRates(v); });
    return () => { alive = false; };
  }, []);
  return rates;
}

/** A rate as copy: 0.02 → "2%", 0.0075 → "0.75%"; '—' until it is known. */
export const pctOf = (r) => (r == null || !Number.isFinite(Number(r)) ? '—' : `${Math.round(Number(r) * 10000) / 100}%`);
